import { render, staticRenderFns } from "./DeviceBoxDialog.vue?vue&type=template&id=7afa57ee&scoped=true&"
import script from "./DeviceBoxDialog.vue?vue&type=script&lang=js&"
export * from "./DeviceBoxDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBoxDialog.vue?vue&type=style&index=0&id=7afa57ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afa57ee",
  null
  
)

export default component.exports